import InternalDeckRenderPage from './InternalDeckRenderPage'

export function InternalDeckRenderRoute() {
  return <InternalDeckRenderPage />
}

export default InternalDeckRenderRoute
